/* eslint-disable camelcase */
import React, { useEffect, useMemo } from 'react';

import PropTypes from 'prop-types';
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
  useHistory,
  useLocation,
} from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import {
  getFinancialCategory,
  getGrandFinancialPlan,
} from '../../data/store/account/accountActions';

import FinancialPlanRoute from './FinancialPlanRoute';
import { ReactComponent as Pluse } from './img/pluse-icon.svg';
import './styles.scss';
import { Button, Col, Layout, Row } from 'antd';

const { Header } = Layout;

const FinancialPlanning = ({ userId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('');
  const location = useLocation();
  const { url } = useRouteMatch();
  const history = useHistory();

  const { financialPlan } = useSelector((state) => state.accountReducer);

  useEffect(() => {
    dispatch(getGrandFinancialPlan(userId));
    dispatch(getFinancialCategory());
    return () => {
      dispatch({ type: 'CLEAR_FINANCAL_PLAN' });
    };
  }, []);

  useEffect(() => {
    console.log('refresh location', location.pathname);

    if (!financialPlan) {
      !location.pathname.includes('stage') && history.replace(`${url}`);
    } else {
      !location.pathname.includes('stage') &&
        history.replace(`${url}/${financialPlan?.id}/stages`);
    }
  }, [financialPlan]);

  const rootPath = useMemo(() => {
    if (financialPlan) {
      return `/accounts/${userId}/lifetiming/${financialPlan?.id}/stages`;
    }
  }, [financialPlan]);

  return (
    <>
      {!financialPlan?.id && !location.pathname.includes('lifetiming/new')
      ? (
        <div className="finplan-summary-container">
        <Header className="headerStyle">
          <Row className="overview-tabs-wrapper">
            <Col className="tabs-tab-wrapper" span={18}>
              <h1 className='suggested-portfolios-title header-plan'>
                {t('LIFETIMING')}
              </h1>
            </Col>
          </Row>
        </Header>
          <div className="finplan-addnew-container">
          <div className="finplan-addnew-wrapper">
            <h2 className="finplan-addnew-title">{t('ADD_FINANCIAL_PLAN')}</h2>
            <Button
              onClick={() => history.push(`${url}/new`)}
              className="finplan-addnew-btn"
            >
              <Pluse style={{width: '24px', height: '24px'}}/>
            </Button>
          </div>
          </div>
        </div>
      ) 
      : (
        <div className="finplan-summary-container">
          <Switch>
            <Route path={`${url}/:finplanId`}>
              <FinancialPlanRoute
                t={t}
                financialPlan={financialPlan}
                userId={userId}
              />
            </Route>
            <Route exact path="*">
              <Redirect to={rootPath} />
            </Route>
          </Switch>
        </div>
      )}
    </>
  );
};

export default FinancialPlanning;

FinancialPlanning.propTypes = {
  userId: PropTypes.string,
  portfolioId: PropTypes.string,
  needSave: PropTypes.bool,
  setNeedSave: PropTypes.func,
  saveAlert: PropTypes.object,
  setSaveAlert: PropTypes.func,
};
